export default "__VITE_ASSET__DkwqH_cD__"